import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { requestLogActions } from "./../../../../store/external/request-reducer/request-log.reducer";
import { requestDetailsActions } from "./../../../../store/external/request-reducer/request-details.reducer";
import { REQUEST_SUB_LINKS as RequestTable, TABLE_PAGINATION_KEY } from "../../../../constants/external-constants";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import "./../request-page.component.css";
import { TablePagination } from "../../../common/details-table/table-pagination.component";

class OrderRequestQuotationTable extends Component {
    constructor(props) {
        super();
    }

    componentWillMount() {
        this.props.setActiveRequestTable(RequestTable.quotationRequest.id);
        this.props.fetchRequestLogItems(0, RequestTable.quotationRequest.id);
    }

    componentWillUnmount() {
        this.props.isDisplaySearch(false);
        this.props.setResetSearch();
        this.props.resetRequestLogData();
    }
    openRequestModal = (item) => {
        const { setSelectedRequest, history } = this.props;
        setSelectedRequest(item, true);
        history.push("QuotationRequest/RequestDetail/Order/" + item.OrderId);
    };

    onColumnSearch = () => {
        const { fetchRequestLogItems } = this.props;
        fetchRequestLogItems(0, RequestTable.quotationRequest.id);
    }

    resizePage = (pageSize) => {
        const { resizeRequestLogs, fetchRequestLogItems} = this.props;
        resizeRequestLogs(pageSize)
        fetchRequestLogItems(0, RequestTable.quotationRequest.id);
    }
    render() {
        const { orderQuotationData, orderQuotationLoaded, orderQuotationFetchError, fetchRequestLogItems, fetchSortedRequestData, setRequestSearchValue } = this.props;

        return (
            <div>
                {
                    orderQuotationLoaded ?
                        orderQuotationFetchError ?
                            <span> Error in fetching data. </span> :
                            <TablePagination
                                    id={RequestTable.allRequest.id}
                                    tablePaginationKey={TABLE_PAGINATION_KEY.requestAllRequest}
                                    columns={orderQuotationData.Headers}
                                    pageList={orderQuotationData.Data}
                                    pages={orderQuotationData.Pagination}
                                    rowClickAction={this.openRequestModal}
                                    paginationAction={fetchRequestLogItems}
                                    onColumnClick={fetchSortedRequestData}
                                    onColumnSearch={() => { this.onColumnSearch() }}
                                    onColumnSearchChange={setRequestSearchValue}
                                    isColSearchShow={this.props.displaySearch}
                                    totalPage={orderQuotationData.Pagination.TotalEntries}
                                    resizePage={this.resizePage}
                                    key="table-pagination-sec"
                                    classNameWrapper="overflow-auto"
                            /> :
                        <div>
                            <NoSubscription customClass="loading-page" title="Loading, Please Wait…" />
                        </div>
                }
            </div>
        );
    }
}

export default connect(
    state => {
        const { requestLog } = state;
        return {
            ...requestLog
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, requestLogActions, requestDetailsActions),
            dispatch
        )
)(OrderRequestQuotationTable);
